const actions = {
  SET_STATE: 'roles/SET_STATE',
  ROLES_LIST: 'roles/ROLES_LIST',
  ADD_ROLE: 'roles/ADD_ROLE',
  GET_ROLE: 'roles/GET_ROLE',
  UPDATE_ROLE: 'roles/UPDATE_ROLE',
  DELETE_ROLE: 'roles/DELETE_ROLE',
  SEARCH_ROLE: 'roles/SEARCH_ROLE',
  ENTER_ROLE_TEXT: 'roles/ENTER_ROLE_TEXT',
  ROLES_PERMISSIONS_LIST: 'roles/ROLES_PERMISSIONS_LIST',
  GET_ROLE_RESTRICTIONS: 'roles/GET_ROLE_RESTRICTIONS',
  ADD_ROLE_RESTRICTION: 'roles/ADD_ROLE_RESTRICTION',
  DELETE_ROLE_RESTRICTION: 'roles/DELETE_ROLE_RESTRICTION',
  ROLES_PERMISSIONS_V2_LIST: 'roles/ROLES_PERMISSIONS_V2_LIST',
  ROLES_PERMISSIONS_V2_VALUES_GET: 'roles/ROLES_PERMISSIONS_V2_VALUES_GET',
  ROLES_PERMISSIONS_V2_UPDATE: 'roles/ROLES_PERMISSIONS_V2_UPDATE',
  ROLES_PERMISSIONS_V2_RESET: 'roles/ROLES_PERMISSIONS_V2_RESET',
}

export default actions
